var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left py-2 px-4 mr-3 my-3 border-solid border-b-2 cursor-pointer",class:this.active ? 'border-blue-500' : 'border-gray-200'},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }